export interface Environment {
  browser: { name: string; version: string }
  device: { model: string; type: string; vendor: string }
  engine: { name: string; version: string }
  os: { name: string; version: string }
}

export interface ILogger {
  debug: (message: string, context?: Metadata) => void
  info: (message: string, context?: Metadata) => void
  warning: (message: string, context?: Metadata) => void
  error: (message: string, context?: Metadata) => void
}

export type Metadata = Record<string, unknown>

export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARNING = 'warn',
  ERROR = 'error',
}

export interface LogPayload {
  message: string
  level: LogLevel
  context: Metadata
}
